<template>
  <v-breadcrumbs class="crumbs-list" :items="breadcrumbs" divider="/">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :to="item.path" :disabled="item.disabled" @click="onBreadcrumbClick(item)">{{ item.name }}</v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        if (to.name === 'Product' || to.name === 'EditProduct') {
          this.$store.dispatch('fetchProduct', to.params.id);
        }
        else if (to.name === 'Postitus') {
          this.$store.dispatch('fetchPost', to.params.id);
        }
      },
    },
  },
  methods: {
    onBreadcrumbClick(item) {
      if (item.path && item.path.startsWith('/tooted') && !item.disabled) {
        sessionStorage.setItem('currentPageProducts', 1);
      }
    },
    capitalizeBreadcrumbName(name) {
      if (typeof name !== 'string') {
        return name;
      }

      const trimmedName = name.trim();
      if (!trimmedName) {
        return trimmedName;
      }

      return trimmedName.charAt(0).toUpperCase() + trimmedName.slice(1);
    },
  },
  computed: {
    product() {
      return this.$store.getters.getProduct;
    },
    post() {
      return this.$store.getters.getPost;
    },
    categories() {
      return this.$store.getters.getCategories;
    },
    breadcrumbs() {
      let breadcrumbs = [];
      const getCategoryBaseName = (category) => category?.name || category?.cat || '';
      const slugifyCategoryPath = (value) => {
        const parts = (value || '').split(' - ').map((part) => part.trim()).filter(Boolean);
        const slugifyPart = (part) => part
            .toLowerCase()
            .replace(/[ä]/g, 'a')
            .replace(/[öõ]/g, 'o')
            .replace(/[ü]/g, 'u')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');

        return parts.map(slugifyPart).filter(Boolean).join('/');
      };
      const getLocalizedCategoryName = (category) => {
        const fallback = getCategoryBaseName(category);

        if (this.$i18n.locale === 'en') {
          return category?.name_en || category?.cat_en || fallback;
        }

        if (this.$i18n.locale === 'ru') {
          return category?.name_ru || category?.cat_ru || fallback;
        }

        return fallback;
      };
      const getParts = (value) => (value || '').split(' - ').map((part) => part.trim()).filter(Boolean);

      const pushBreadcrumb = (item) => {
        if (!item || !item.name || String(item.name).trim() === '') {
          return;
        }
        if (!breadcrumbs.some((breadcrumb) => breadcrumb.name === item.name && breadcrumb.path === item.path)) {
          breadcrumbs.push(item);
        }
      };

      const appendCategoryTrail = (categorySlug) => {
        if (!categorySlug) {
          return false;
        }

        const slugParts = String(categorySlug).split('/').map((part) => part.trim()).filter(Boolean);
        if (!slugParts.length) {
          return false;
        }

        const exactCategory = this.categories.find(
            (obj) => slugifyCategoryPath(getCategoryBaseName(obj)) === categorySlug
        );

        if (exactCategory) {
          const keyParts = getParts(getCategoryBaseName(exactCategory));
          const localizedParts = getParts(getLocalizedCategoryName(exactCategory));

          keyParts.forEach((part, index) => {
            const pathParts = keyParts.slice(0, index + 1).join(' - ');
            pushBreadcrumb({
              path: `/tooted/${slugifyCategoryPath(pathParts)}`,
              name: localizedParts[index] || part,
              disabled: false,
            });
          });

          return true;
        }

        const groupedCategory = this.categories.find((obj) => {
          const parts = getParts(getCategoryBaseName(obj));
          if (parts.length < slugParts.length) {
            return false;
          }

          const partialKey = parts.slice(0, slugParts.length).join(' - ');
          return slugifyCategoryPath(partialKey) === categorySlug;
        });

        if (!groupedCategory) {
          return false;
        }

        const keyParts = getParts(getCategoryBaseName(groupedCategory));
        const localizedParts = getParts(getLocalizedCategoryName(groupedCategory));

        slugParts.forEach((_, index) => {
          const pathParts = keyParts.slice(0, index + 1).join(' - ');
          pushBreadcrumb({
            path: `/tooted/${slugifyCategoryPath(pathParts)}`,
            name: localizedParts[index] || keyParts[index],
            disabled: false,
          });
        });

        return true;
      };

      this.$route.matched.forEach((route, index) => {
        let name;
        let path = route.path;
        if (route.meta.dynamicName) {
          if (route.name === 'ToodeteKategooriad') {
            const categorySlug = this.$route.params.categoryPath;
            if (appendCategoryTrail(categorySlug)) {
              return;
            }
          }
          else if (route.name === 'Product' || route.name === 'EditProduct') {
            appendCategoryTrail(this.$route.params.categoryPath);
            name = this.product ? (this.$i18n.locale === 'en' ? this.product.header_en : this.$i18n.locale === 'ru' ? this.product.header_ru : this.product.header) : '';
            path = this.$route.path;
          }
          else if (route.name === 'Postitus') {
            name = this.post ? ((this.$i18n.locale === 'en' && this.post.header_en !== null) ? this.post.header_en : (this.$i18n.locale === 'ru' && this.post.header_ru !== null) ? this.post.header_ru : this.post.header) : '';
            if (name.length > 40) {
              name = name.substring(0, 40) + '...';
            }
            path = path.replace(':id', this.$route.params.id);
          }
        }
        else name = route.meta && route.meta.breadcrumb 
              ? route.meta.breadcrumb 
              : this.$t(route.name.toLowerCase());

        if (route.meta && !route.meta.dynamicName) {
          name = this.capitalizeBreadcrumbName(name);
        }
        pushBreadcrumb({ path: path, name: name, disabled: false });
      });
      if (breadcrumbs.length > 0) {
        breadcrumbs[breadcrumbs.length - 1].disabled = true; // disable the last item
      }
      return [{ path: '/', name: this.$t('avaleht') }, ...breadcrumbs];
    },
  },

}
</script>

<!-- https://codepen.io/mrtnvh/pen/DwdjXW -->
<style lang="scss">
.crumbs-list {
  padding: 1em;
  white-space:nowrap;
  overflow-y: hidden;
  overflow-x: auto;
  font-size: 15px;
  line-height: 14px;
  list-style: none;
  width: 100%;
  margin: 0;
  justify-content: right;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
  & {
    -ms-overflow-style: none;
  }
  li {
    &:after {
      padding: 0 0.25em 0 0.5em;
      color: #999;
    }
    &.last:before, &.last:after {
      content: '';
    }
  }
}

@media (max-width: 1000px) {
  .crumbs-list {
    justify-content: center;
  }
}
</style>